<template>
  <div
    class="password-container w-full px-4 py-4 bg-[#151A1F] flex flex-col justify-center items-center"
  >
    <div class="text-white/70 text-[14px] w-full mb-4 text-left">{{ title }}</div>
    <div class="input-box flex justify-between w-full px-2" @click="focusInput">
      <div
        v-for="(_, index) in 6"
        :key="index"
        class="box w-[40px] h-[40px] border-2 border-[#64F765] flex items-center justify-center"
      >
        <span
          v-if="index < password.length"
          class="dot bg-white w-[10px] h-[10px] rounded-full"
        ></span>
      </div>
    </div>
    <input
      ref="hiddenInput"
      type="number"
      class="hidden-input absolute opacity-0 pointer-events-none"
      v-model="password"
      maxlength="6"
      @input="handleInput"
    />
  </div>
</template>

<script setup lang="ts">
const hiddenInput = ref<HTMLInputElement | null>(null);
const password = ref("");
const focusInput = () => {
  hiddenInput.value?.focus();
};
const { title } = defineProps<{
  title: string;
}>();
const emit = defineEmits(["update:modelValue", "next"]);
const handleInput = (event: Event) => {
  const input = event.target as HTMLInputElement;
  password.value = input.value.slice(0, 6);
  emit("update:modelValue", password.value);
};
</script>

<style scoped lang="scss">
.password-container {
  .box {
    background-color: #2c795266;
  }
  .confirm-button:disabled {
    background-color: #555;
    cursor: not-allowed;
  }
}
</style>
